import React from 'react';
import Text from '../text/Text';
import Button from '../button/Button';
import './NavigationAlert.scss';

interface INavigationAlert {
  className?: string,
  title: string,
  subTitle: string | JSX.Element,
  shouldTranslateTitle?: boolean,
  shouldTranslateSubTitle?: boolean,
  buttonLabel: string,
  shouldTranslateButtonLabel?: boolean,
  icon?: string,
  onClick: () => void
}

const NavigationAlert: React.FC<INavigationAlert> = ({ className = "", title, subTitle, shouldTranslateTitle = true, 
  shouldTranslateSubTitle = true, buttonLabel, shouldTranslateButtonLabel = true, icon = "fas fa-rocket", onClick }) => {

  return (
    <div className={`navigation-alert ${className}`}>
      <div>
        <Text content={title} shouldTranslate={shouldTranslateTitle} className="navigation-alert__title" noMargin />
        <Text content={subTitle} shouldTranslate={shouldTranslateSubTitle} className="navigation-alert__subTitle" noMargin />
      </div>
      <Button
        id="navigation-alert-btn"
        className="navigation-alert__btn"
        title={buttonLabel}
        icon={icon}
        onClick={onClick}
        shouldTranslate={shouldTranslateButtonLabel}
        isVisible={!!buttonLabel}
      />
    </div>
  )
}

export default NavigationAlert;